export default __webpack_public_path__ + "static/media/zcLogo.ebc9bfcc.svg";